import { request } from './client.js';

export interface PublicationDto {
  readonly bookId: string;
  readonly published: boolean;
  readonly publishedAt: string | null;
  /** `null`, пока книга ни разу не публиковалась. */
  readonly url: string | null;
}

export const publicationApi = {
  get: (bookId: string) => request<PublicationDto>(`/books/${bookId}/publication`),
  /**
   * Согласие на распространение уходит явным полем, а не подразумевается самим
   * запросом: сервер обязан отличить подтверждённое согласие от его отсутствия
   * (ст. 10.1 152-ФЗ), а не выводить его из факта нажатия кнопки.
   */
  publish: (bookId: string) =>
    request<PublicationDto>(`/books/${bookId}/publication`, {
      method: 'POST',
      body: { consent: true },
    }),
  unpublish: (bookId: string) =>
    request<PublicationDto>(`/books/${bookId}/publication`, { method: 'DELETE' }),
};
